import { SimNaoEnum } from 'components/form'

import { ExemplosVerticalFieldModel } from '../../components/ExemplosVerticalField'
import { ConsultaSeguimentoAplicacaoItemModel, PassouFalhouEnum } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta10ExemplosEnum {
  PROCURA = 'PROCURA',
  FALA_OU_EMITE_SOM = 'FALA_OU_EMITE_SOM',
  PARA_O_QUE_ESTA_FAZENDO = 'PARA_O_QUE_ESTA_FAZENDO',
  NAO_DA_RESPOSTA = 'NAO_DA_RESPOSTA',
  PARECE_OUVIR_IGNORA = 'PARECE_OUVIR_IGNORA',
  SO_RESPONDE_NA_FRENTE = 'SO_RESPONDE_NA_FRENTE',
  SO_RESPONDE_SE_TOCADO = 'SO_RESPONDE_SE_TOCADO',
}

export interface ConsultaSeguimentoPergunta10Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_10_HEADER?: SimNaoEnum
  PERGUNTA_10_EXEMPLOS?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta10ExemplosEnum>
  PERGUNTA_10_FREQUENCIA?: PassouFalhouEnum
}
